// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.enums.TopConstructionStatus

export enum TopConstructionStatus {
  COMPLETE = 'COMPLETE',
  PLANNED_DEVELOPMENT = 'PLANNED_DEVELOPMENT',
  UNDER_CONSTRUCTION = 'UNDER_CONSTRUCTION',
}

export const TopConstructionStatus_values = [
  TopConstructionStatus.COMPLETE,
  TopConstructionStatus.PLANNED_DEVELOPMENT,
  TopConstructionStatus.UNDER_CONSTRUCTION,
] as const;
